import App from './App';
import appRenderer from 'utils/appRenderer';

appRenderer(<App />);
